/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHarmfulFactorDto } from './GetHarmfulFactorDto';
import {
    GetHarmfulFactorDtoFromJSON,
    GetHarmfulFactorDtoFromJSONTyped,
    GetHarmfulFactorDtoToJSON,
} from './GetHarmfulFactorDto';
import type { GetSupportingExaminationDictDto } from './GetSupportingExaminationDictDto';
import {
    GetSupportingExaminationDictDtoFromJSON,
    GetSupportingExaminationDictDtoFromJSONTyped,
    GetSupportingExaminationDictDtoToJSON,
} from './GetSupportingExaminationDictDto';

/**
 * 
 * @export
 * @interface GetArticleHarmfulFactorSuppExamDictDto
 */
export interface GetArticleHarmfulFactorSuppExamDictDto {
    /**
     * 
     * @type {string}
     * @memberof GetArticleHarmfulFactorSuppExamDictDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetArticleHarmfulFactorSuppExamDictDto
     */
    harmfulFactorId?: string | null;
    /**
     * 
     * @type {GetHarmfulFactorDto}
     * @memberof GetArticleHarmfulFactorSuppExamDictDto
     */
    harmfulFactor?: GetHarmfulFactorDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetArticleHarmfulFactorSuppExamDictDto
     */
    supportingExaminationDictId?: string | null;
    /**
     * 
     * @type {GetSupportingExaminationDictDto}
     * @memberof GetArticleHarmfulFactorSuppExamDictDto
     */
    supportingExaminationDict?: GetSupportingExaminationDictDto;
}

/**
 * Check if a given object implements the GetArticleHarmfulFactorSuppExamDictDto interface.
 */
export function instanceOfGetArticleHarmfulFactorSuppExamDictDto(value: object): value is GetArticleHarmfulFactorSuppExamDictDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetArticleHarmfulFactorSuppExamDictDtoFromJSON(json: any): GetArticleHarmfulFactorSuppExamDictDto {
    return GetArticleHarmfulFactorSuppExamDictDtoFromJSONTyped(json, false);
}

export function GetArticleHarmfulFactorSuppExamDictDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetArticleHarmfulFactorSuppExamDictDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'harmfulFactorId': json['harmfulFactorId'] == null ? undefined : json['harmfulFactorId'],
        'harmfulFactor': json['harmfulFactor'] == null ? undefined : GetHarmfulFactorDtoFromJSON(json['harmfulFactor']),
        'supportingExaminationDictId': json['supportingExaminationDictId'] == null ? undefined : json['supportingExaminationDictId'],
        'supportingExaminationDict': json['supportingExaminationDict'] == null ? undefined : GetSupportingExaminationDictDtoFromJSON(json['supportingExaminationDict']),
    };
}

export function GetArticleHarmfulFactorSuppExamDictDtoToJSON(value?: GetArticleHarmfulFactorSuppExamDictDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'harmfulFactorId': value['harmfulFactorId'],
        'harmfulFactor': GetHarmfulFactorDtoToJSON(value['harmfulFactor']),
        'supportingExaminationDictId': value['supportingExaminationDictId'],
        'supportingExaminationDict': GetSupportingExaminationDictDtoToJSON(value['supportingExaminationDict']),
    };
}

